import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectTheme } from '@/state/general/generalSelectors';
import { THEME_VARIANTS } from '@/state/member/memberTypes';

/**
 * Syncs a `data-theme` attribute on `<html>` ("light" | "dark") based on
 * the Redux theme preference. This drives theme-aware CSS variables defined
 * in colors.scss.
 *
 * Product-level theming (dashboard vs hypertracker) is handled by MUI
 * ThemeProvider, not CSS variables.
 */
const DataThemeSync: React.FC = () => {
    const storedTheme = useSelector(selectTheme);

    useEffect(() => {
        const mode = storedTheme === THEME_VARIANTS.LIGHT ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', mode);
    }, [storedTheme]);

    return null;
};

export default DataThemeSync;
